module.exports = __webpack_public_path__ + "img/gerüstbohlen-hocker-konfigurator.6260858a.jpeg";